interface GetTableFieldNameProps {
  fieldName: string
  rowSubLinesFieldName: string
  index: number
}

export const getSubLineTableFieldName = ({ rowSubLinesFieldName, fieldName, index }: GetTableFieldNameProps) => {
  return `${rowSubLinesFieldName}.${index}.${fieldName}`
}
